import React from 'react'

import styles from '../../../Products.module.scss'

import { SettingsAdjust as SettingsIcon } from '../../../../../icons'
import CustomSelect from 'components/elements/inputs/CustomSelect'
import InputGroup from 'components/elements/forms/InputGroup'
import { ISelectOption } from 'components/elements/inputs/CustomSelect/CustomSelect'
import ProxyConfigurationForm from '../../ProxyConfigurationForm'

import { ProxyPoolDescription } from 'utils/proxy/proxyConstants'

interface IProxyConnectConfigurationProps {
  selectedProxyType: any
  selectedTimeInterval: any
  customTimeInterval: string
  selectedCountry: any
  selectedRegion: any
  selectedCity: any
  selectedIsp: any
  isBindIPActive: boolean
  selectedBindTtl: any
  customBindTtl: string
  activeSessionLengthType: any
  sessionPrefix: string
  selectedProxyModifier: string
  proxyTypesOptions: ISelectOption[]
  availableSessionIntervals: ISelectOption[]
  onProxyTypeChange: (option: ISelectOption) => void
  onCountryChange: (option: ISelectOption) => void
  onRegionChange: (option: ISelectOption) => void
  onCityChange: (option: ISelectOption) => void
  onIspChange: (option: ISelectOption) => void
  onDeepTargetsReset: () => void
  onTimeIntervalChange: (option: ISelectOption) => void
  onCustomTimeIntervalChange: (val: string) => void
  onBindIp: () => void
  onBindTtlChange: (option: ISelectOption) => void
  onCustomBindTtlChange: (val: string) => void
  onActiveSessionLengthChange: (e: any) => void
  onSessionPrefixChange: (e: any) => void
  onProxyModifierChange: (val: string) => void
  onGenerateIpClick: () => void
}

const ProxyQuickConfiguration: React.FC<IProxyConnectConfigurationProps> = (
  props
) => {
  const {
    selectedProxyType,
    selectedCountry,
    selectedRegion,
    selectedCity,
    selectedIsp,
    selectedTimeInterval,
    customTimeInterval,
    isBindIPActive,
    selectedBindTtl,
    customBindTtl,
    activeSessionLengthType,
    sessionPrefix,
    proxyTypesOptions,
    availableSessionIntervals,
    selectedProxyModifier,
    onProxyTypeChange,
    onCountryChange,
    onRegionChange,
    onCityChange,
    onIspChange,
    onDeepTargetsReset,
    onTimeIntervalChange,
    onCustomTimeIntervalChange,
    onBindIp,
    onBindTtlChange,
    onCustomBindTtlChange,
    onActiveSessionLengthChange,
    onSessionPrefixChange,
    onProxyModifierChange,
    onGenerateIpClick,
  } = props

  const handleProxyTypeChange = (option: any) => {
    onProxyTypeChange(option)
  }

  return (
    <div className={styles.blockMain}>
      <div className={styles.blockHeader}>
        <div className={styles.headerIconWrapper}>
          <SettingsIcon />
        </div>
        <span className={styles.blockTitle}>Connection setup</span>
      </div>

      <InputGroup
        className={styles.proxyTypeGroup}
        labelTop={'Proxy type'}
        boldLabel
        name={'pool_select_group_quick'}
        description={ProxyPoolDescription}
      >
        <CustomSelect
          onChange={handleProxyTypeChange}
          value={selectedProxyType}
          name={'proxy-type-select'}
          options={proxyTypesOptions}
          isSearchable={false}
        />
      </InputGroup>

      <ProxyConfigurationForm
        settingsSection={'quick_connect'}
        selectedCountry={selectedCountry}
        selectedRegion={selectedRegion}
        selectedCity={selectedCity}
        selectedIsp={selectedIsp}
        activeSessionLengthType={activeSessionLengthType}
        selectedTimeInterval={selectedTimeInterval}
        customTimeInterval={customTimeInterval}
        selectedProxyType={selectedProxyType}
        isBindIPActive={isBindIPActive}
        selectedBindTtl={selectedBindTtl}
        customBindTtl={customBindTtl}
        sessionPrefix={sessionPrefix}
        availableTimeIntervals={availableSessionIntervals}
        selectedProxyModifier={selectedProxyModifier}
        onCountryChange={onCountryChange}
        onRegionChange={onRegionChange}
        onCityChange={onCityChange}
        onIspChange={onIspChange}
        onDeepTargetsReset={onDeepTargetsReset}
        onActiveSessionLengthChange={onActiveSessionLengthChange}
        onTimeIntervalChange={onTimeIntervalChange}
        onCustomTimeIntervalChange={onCustomTimeIntervalChange}
        onBindIp={onBindIp}
        onBindTtlChange={onBindTtlChange}
        onCustomBindTtlChange={onCustomBindTtlChange}
        onSessionPrefixChange={onSessionPrefixChange}
        onProxyModifierChange={onProxyModifierChange}
        onGenerateIpClick={onGenerateIpClick}
      />
    </div>
  )
}

export default ProxyQuickConfiguration
